var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceEon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#286385",
    stroke: "#286385",
    style: {
      fill: "#9d1207",
      stroke: "#9d1207"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25 15.5c1.7604 0 3.1875-1.4271 3.1875-3.1875s-1.4271-3.1875-3.1875-3.1875-3.1875 1.4271-3.1875 3.1875 1.4271 3.1875 3.1875 3.1875z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.469 34.625h.3186c.2279 8e-4.4479-.0839.6165-.2373s.2736-.3644.2942-.5915l.7468-8.0144h1.1114l.7468 8.0144c.0206.227.1255.438.2941.5914.1685.1535.3884.2381.6164.2374h.3187c.2413-7e-4.4726-.0969.6432-.2675.1707-.1707.2669-.4019.2676-.6433v-7.9324h1.6394c.2413-7e-4.4725-.0968.6431-.2674.1707-.1706.2669-.4018.2677-.6431v-4.7631c8e-4-.3351-.0646-.6671-.1924-.9769-.1279-.3098-.3157-.5912-.5527-.8281-.237-.237-.5185-.4248-.8282-.5526-.3098-.1278-.6418-.1932-.9769-.1923h-6.885c-.3351-9e-4-.6671.0645-.9769.1923s-.5913.3156-.8282.5526c-.237.2369-.4248.5184-.5527.8281-.1278.3098-.1932.6418-.1924.9769v4.7632c8e-4.2412.097.4724.2676.643.1707.1706.4019.2668.6432.2675h1.6394v7.9323c6e-4.2414.0968.4726.2675.6433.1706.1707.4019.2668.6432.2675z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25 38.875c6.2453 0 12.883-2.0016 12.883-5.711 0-2.1405-2.277-3.9428-6.2479-4.9452-.1354-.0346-.2764-.0421-.4148-.0222-.1384.02-.2715.0671-.3916.1386-.1202.0715-.2251.166-.3086.2781-.0836.1121-.1442.2396-.1784.3752-.0342.1355-.0413.2765-.0209.4148.0203.1384.0678.2713.1397.3913.0719.1199.1667.2245.2791.3077.1123.0832.24.1434.3757.1772 3.1896.8052 4.6427 2.0596 4.6427 2.8845 0 1.462-4.1908 3.586-10.758 3.586s-10.758-2.124-10.758-3.586c0-.8373 1.4827-2.1052 4.7382-2.9084.2735-.0675.509-.241.6547-.4821.1456-.2412.1895-.5304.1219-.8039-.0675-.2736-.241-.5091-.4822-.6547-.2412-.1457-.5303-.1896-.8039-.122-4.0378.9961-6.3537 2.8077-6.3537 4.9711 0 3.7094 6.6375 5.711 12.883 5.711z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceEon);
export default __webpack_public_path__ + "static/media/spaceEON.03a77ebe558c5b95ad8ae4fb37147f02.svg";
export { ForwardRef as ReactComponent };